var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 141",
    d: "M6.5 5.14239L6.5 3.4709C6.5 2.30611 6.5 1.72371 6.84942 1.36186C7.19883 1 7.76121 1 8.88596 1L12.114 1C13.2388 1 13.8012 1 14.1506 1.36186C14.5 1.72371 14.5 2.30611 14.5 3.4709V5.14239",
    stroke: "#EF3F3F",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 151",
    d: "M12.5 10.2148V15.2148",
    stroke: "#EF3F3F",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 152",
    d: "M8.5 10.2148V15.2148",
    stroke: "#EF3F3F",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 18313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 976",
    d: "M10.499 20C9.14321 20 8.2012 19.999 7.47168 19.9248C6.84944 19.8615 6.46067 19.7506 6.16504 19.5889L6.04395 19.5166C5.84855 19.3898 5.6684 19.2412 5.50781 19.0732L5.35449 18.8994C5.12 18.6127 4.94189 18.2239 4.79199 17.5254C4.67663 16.9877 4.58868 16.3263 4.48926 15.4609L4.38477 14.5234L3.38086 5.43066L17.6172 5.43066L16.6133 14.5234C16.4644 15.8714 16.3599 16.8083 16.2061 17.5254C16.0749 18.1364 15.9225 18.5101 15.7295 18.7861L15.6445 18.8994C15.4971 19.0796 15.329 19.2417 15.1445 19.3828L14.9541 19.5166C14.6434 19.7181 14.2379 19.8525 13.5273 19.9248C12.9801 19.9805 12.3128 19.9952 11.4414 19.999L10.499 20Z",
    stroke: "#EF3F3F",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 155",
    d: "M1.5 5.12109H19.5",
    stroke: "#EF3F3F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconRed);
export default __webpack_public_path__ + "static/media/deleteIconRed.d791274c71f6fa6309b848becd6e234c.svg";
export { ForwardRef as ReactComponent };